// extracted by mini-css-extract-plugin
export var lg = "_4b-4";
export var md = "_4b-3";
export var sm = "_4b-2";
export var xs = "_4b-1";
export var xxs = "_4b-0";